import React from "react";
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@mui/material';
import { useState } from "react";
import { UserContext } from "./services/Context/UserContext.js";
import { ToastContext } from "./services/Context/ToastContext.js";
import { useMemo } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import 'moment/locale/fr';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import Toast from "./components/Tools/Toast.js";
import Router from "./Router.js";
import { setupLang } from "./services/translation.js";
import "./index.css";
import theme from "./services/theme.js";

setupLang();

LicenseInfo.setLicenseKey(
  'ebfad3f8005def39cba31bc8fccc5a18Tz02ODE0MyxFPTE3MTc3NjQ4MjkwMjUsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y',
);

const queryClient = new QueryClient();

function App() {

  const [user, setUser] = useState(null)
  const userMemo = useMemo(() => ({user, setUser}), [user, setUser])

  const [toast, setToast] = useState(null)
  const toastMemo = useMemo(() => ({toast, setToast}), [toast, setToast])

  return (
    <QueryClientProvider client={queryClient} contextSharing={true}>

    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='fr'>

    <UserContext.Provider value={userMemo} >

    <ThemeProvider theme={theme}>

    <ToastContext.Provider value={toastMemo} >

    <Router />

    <Toast
      open={toast ? true : false}
      severity={toast?.severity}
      message={toast?.message}
      onClose={() => setToast(null)}
      duration={toast?.duration || 2000}
    />

    </ToastContext.Provider>
        
    </ThemeProvider>

    </UserContext.Provider>

    </LocalizationProvider>
        
    </QueryClientProvider>
  )
}


export default App;
